import { Component, ViewEncapsulation } from '@angular/core';
import { AppBasicsModule } from '@meddev/fe-shared';

@Component({
    selector: 'lay-men-footer',
    templateUrl: './lay-men-footer.component.html',
    styleUrls: ['./lay-men-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [AppBasicsModule],
})
export class LayMenFooterComponent {}
